import React from 'react';

/**
 * Caps the usable width on large screens (desktop / widescreen) so the app
 * keeps a phone-like column instead of stretching across the full viewport.
 * Content is centered; the surroundings are filled with a neutral backdrop.
 */
export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen w-full bg-gray-100">
      <div className="mx-auto w-full max-w-md min-h-screen bg-gray-50 shadow-2xl">
        {children}
      </div>
    </div>
  );
}